
const ADMIN = "ADMIN";
const FINANCE = "FINANCE";
const TEAM = "TEAM";
const VENDOR = "VENDOR";
const DIRECTOR = "DIRECTOR";

const isAdminRole = (role) => role === ADMIN || role === "BOOKKEEPER" || role === "OWNER";

const ACTIVE = "ACTIVE";
const INACTIVE = "DELETED";

const TAB_FINANCE = "finance";
const TAB_MARKETING = "marketing";
const TAB_MERCHANDISING = "merchandising";
const TAB_FULFILLMENT = "fulfillment";
const TAB_INVENTORY = "inventory";
const TAB_VENDORS = "vendors";
const TAB_UTILITIES = "utilities";

const CHILDREN_TAB_ACCOUNTS_PAYABLE = "accounts-payable";
const CHILDREN_TAB_PROFIT_AND_LOSS = "profit-and-loss";
const CHILDREN_TAB_EFFECTIVE_CAPITAL_SUMMARY = "effective-capital-summary";
const CHILDREN_TAB_THIRTEEN_WEEK_CASH_FLOW = "thirteen-week-cash-flow";
const CHILDREN_TAB_CASH_FLOW = "cash-flow";
const CHILDREN_TAB_BALANCE_SHEET = "balance-sheet";
const CHILDREN_TAB_COGS_CANONICAL_VIEW = "cogs-canonical-view";
const CHILDREN_TAB_BUDGET = "budget";
const CHILDREN_TAB_FORECAST_PLANNING_SYSTEM = "forecast-planning-system";
const CHILDREN_TAB_DEMAND_PLANNING = "demand-planning";
const CHILDREN_TAB_DEMAND_PLAN_SHEET_IMPORT = "demand-plan-sheet-import";
const CHILDREN_TAB_FORECAST = "forecast";
const CHILDREN_TAB_FINANCE_CHAT = "finance-chat";
const CHILDREN_TAB_BUDGET_X_FORECAST = "budget-x-forecast";
const CHILDREN_TAB_BUDGET_SHEET_IMPORT = "budget-sheet-import";
const CHILDREN_TAB_BUDGET_TEMPLATE_SHEET_LOAD = "budget-template-sheet-load";
const CHILDREN_TAB_PRODUCTS_CATALOG = "products-catalog";
const CHILDREN_TAB_MERCHANDISING_KPIS = "merchandising-kpis";
const CHILDREN_TAB_SKU_MAPPING = "sku-mapping";
const CHILDREN_TAB_BOM = "bom";
const CHILDREN_TAB_INVENTORY_RECLASSIFY = "inventory-reclassify";
const CHILDREN_TAB_HOURLY_PERFORMANCE = "hourly-performance";
const CHILDREN_TAB_SHIPMENTS = "shipments";
const CHILDREN_TAB_ORDERS = "orders";
const CHILDREN_TAB_PURCHASE_ORDERS = "purchase-orders";
const CHILDREN_TAB_RECEIVED_BOXES = "received-boxes";
const CHILDREN_TAB_LOCATION_MASTER = "location-master";
const CHILDREN_TAB_INVENTORY_LEDGER = "inventory-ledger";
const CHILDREN_TAB_PICK_PACK_REPORT = "pick-pack-report";
const CHILDREN_TAB_INBOUND_RECEIVING_PUTAWAY = "inbound-receiving-putaway";
const CHILDREN_TAB_CONSOLIDATION = "consolidation";
const CHILDREN_TAB_LOCATION_CAPACITY = "location-capacity";
const CHILDREN_TAB_LOCATION_CAPACITY_SHEET_SYNC = "location-capacity-sheet-sync";
const CHILDREN_TAB_FBA_TRANSFERS = "fba-transfers";
const CHILDREN_TAB_AMAZON_FBA_INVENTORY = "amazon-fba-inventory";
const CHILDREN_TAB_INVENTORY_TRANSFERS = "inventory-transfers";
const CHILDREN_TAB_RETURNS_RECEIVING = "returns-receiving";
const CHILDREN_TAB_RETURNS_PROCESSING_REPORT = "returns-processing-report";
const CHILDREN_TAB_OPEN_TO_BUY = "open-to-buy";
const CHILDREN_TAB_DEMAND_DESTRIBUTON_PROFILE = "demand-destribution-profile";
const CHILDREN_TAB_STOCK_LEVELS = "stock-levels";
const CHILDREN_TAB_STOCK_LEVELS_AMAZON_FBA = "stock-levels-amazon-fba";
const CHILDREN_TAB_AMAZON_FBA_LOW_STOCK_ALERTS = "amazon-fba-low-stock-alerts";
const CHILDREN_TAB_PRODUCTS = "products";
const CHILDREN_TAB_CATALOG = "catalog";
const CHILDREN_TAB_SUPPLIERS = "suppliers";
const CHILDREN_TAB_REPORTS = "reports";
const CHILDREN_TAB_AMAZON_PROFIT_BY_PRODUCT = "amazon-profit-by-product";
const CHILDREN_TAB_AMAZON_PROFIT_BY_SKU = "amazon-profit-by-sku";
const CHILDREN_TAB_MEC_CLOSE_CHECKLIST = "mec-close-checklist";
const CHILDREN_TAB_MEC_CLOSE_APPROVAL = "mec-close-approval";
const CHILDREN_TAB_MEC_JE_DRAFTS = "mec-je-drafts";
const CHILDREN_TAB_MEC_JE_POSTING = "mec-je-posting";
const CHILDREN_TAB_MEC_EVIDENCE_IMPORTS = "mec-evidence-imports";
const CHILDREN_TAB_MEC_CLOSE_CONFIG = "mec-close-config";
const CHILDREN_TAB_MEC_CLOSE_CERTIFICATION = "mec-close-certification";
const CHILDREN_TAB_MEC_SUPPORTING_REPORTS = "mec-supporting-reports";
const CHILDREN_TAB_MEC_PHYSICAL_ROLLFORWARD = "mec-physical-rollforward";
const CHILDREN_TAB_MONTH_END_INVENTORY = "month-end-inventory";
const CHILDREN_TAB_USERS = "users";
const CHILDREN_TAB_CRON = "cron";
const CHILDREN_TAB_APP_NOTES = "app-notes";
const CHILDREN_TAB_NOTIFICATION_SETTINGS = "notification-settings";
const CHILDREN_TAB_EXISTED_SKUS_COMPARISON = "existed-skus-comparison";
const CHILDREN_TAB_KLAVIYO_ANALYTICS = "klaviyo-analytics";
const CHILDREN_TAB_CREATIVE_OS_MIRROR = "creative-os-mirror";
const CHILDREN_TAB_TRYBE_CONTEST = "trybe-contest";

// Retired dashboards; stripped from role permissions.
const DEPRECATED_PERMISSION_CHILDREN = [
    CHILDREN_TAB_PRODUCTS,
    CHILDREN_TAB_CATALOG,
    CHILDREN_TAB_BUDGET,
    CHILDREN_TAB_FORECAST,
    CHILDREN_TAB_FINANCE_CHAT,
];

// Children that now live under Merchandising; stored permissions may still
// carry them under their former parent tab (inventory / fulfillment).
const MERCHANDISING_ADOPTED_CHILDREN = [
    CHILDREN_TAB_STOCK_LEVELS,
    CHILDREN_TAB_PRODUCTS_CATALOG,
    CHILDREN_TAB_SKU_MAPPING,
    CHILDREN_TAB_BOM,
    CHILDREN_TAB_INVENTORY_RECLASSIFY,
    CHILDREN_TAB_PURCHASE_ORDERS,
];

// Current parent tab for children that moved between groups; stored
// permissions may still carry them under their former parent tab.
const ADOPTED_CHILD_TARGET_TABS = {
    ...MERCHANDISING_ADOPTED_CHILDREN.reduce((acc, child) => ({ ...acc, [child]: TAB_MERCHANDISING }), {}),
    [CHILDREN_TAB_HOURLY_PERFORMANCE]: TAB_FINANCE,
    [CHILDREN_TAB_REPORTS]: TAB_FINANCE,
};

// Remaps adopted children from their legacy parent groups into their current
// parent tab and drops groups left empty, preserving stored access levels.
const normalizeLegacyPermissionParents = (permissions) => {
    let parsedPermissions = permissions;
    if (typeof permissions === 'string') {
        try {
            parsedPermissions = JSON.parse(permissions);
        } catch (_error) {
            parsedPermissions = [];
        }
    }
    if (!Array.isArray(parsedPermissions)) return [];
    const adoptedByTab = {};
    const remapped = parsedPermissions.map((group) => {
        const [tabKey, children] = Object.entries(group || {})[0] || [];
        if (!tabKey || !Array.isArray(children)) return group;
        const kept = children.filter((child) => {
            const childKey = Object.keys(child || {})[0];
            const targetTab = ADOPTED_CHILD_TARGET_TABS[childKey];
            if (targetTab && targetTab !== tabKey) {
                (adoptedByTab[targetTab] = adoptedByTab[targetTab] || []).push(child);
                return false;
            }
            return true;
        });
        return { [tabKey]: kept };
    });
    if (!Object.keys(adoptedByTab).length) return parsedPermissions;
    const result = [];
    const mergedTabs = new Set();
    remapped.forEach((group) => {
        const [tabKey, children] = Object.entries(group || {})[0] || [];
        const adopted = adoptedByTab[tabKey];
        if (adopted) {
            const existing = (children || []).map((child) => Object.keys(child || {})[0]);
            const additions = adopted.filter((child) => !existing.includes(Object.keys(child || {})[0]));
            result.push({ [tabKey]: [...(children || []), ...additions] });
            mergedTabs.add(tabKey);
            return;
        }
        if (Array.isArray(children) && children.length === 0) return;
        result.push(group);
    });
    Object.entries(adoptedByTab).forEach(([tabKey, adopted]) => {
        if (!mergedTabs.has(tabKey)) result.push({ [tabKey]: adopted });
    });
    return result;
};

const enumPermissions = {
    [TAB_FINANCE]: "FINANCE",
    [TAB_MARKETING]: "MARKETING",
    [TAB_FULFILLMENT]: "FULFILLMENT",
    [TAB_MERCHANDISING]: "MERCHANDISING",
    [TAB_INVENTORY]: "INVENTORY",
    [TAB_VENDORS]: "VENDORS",
    [TAB_UTILITIES]: "UTILITIES"
};

const enumPermissionChildren = {
  [CHILDREN_TAB_ACCOUNTS_PAYABLE]: "PO Accounts Payable",
  [CHILDREN_TAB_PROFIT_AND_LOSS]: "Profit and Loss",
  [CHILDREN_TAB_CASH_FLOW]: "Cash Flow",
  [CHILDREN_TAB_EFFECTIVE_CAPITAL_SUMMARY]: "Effective Capital Summary",
  [CHILDREN_TAB_THIRTEEN_WEEK_CASH_FLOW]: "13-Week Cash Flow",
  [CHILDREN_TAB_BALANCE_SHEET]: "Balance Sheet",
  [CHILDREN_TAB_COGS_CANONICAL_VIEW]: "COGS Canonical View",
  [CHILDREN_TAB_BUDGET_X_FORECAST]: "Budget",
  [CHILDREN_TAB_BUDGET_SHEET_IMPORT]: "Budget Sheet Import",
  [CHILDREN_TAB_BUDGET_TEMPLATE_SHEET_LOAD]: "Budget Template · Load from Sheet",
  [CHILDREN_TAB_FORECAST_PLANNING_SYSTEM]: "Forecast Planning System",
  [CHILDREN_TAB_DEMAND_PLANNING]: "Demand Planning",
  [CHILDREN_TAB_DEMAND_PLAN_SHEET_IMPORT]: "Demand Plan Sheet Import",
  [CHILDREN_TAB_RECEIVED_BOXES]: "Receiving",
  [CHILDREN_TAB_LOCATION_MASTER]: "Location Master",
  [CHILDREN_TAB_INVENTORY_LEDGER]: "Inventory Ledger",
  [CHILDREN_TAB_PICK_PACK_REPORT]: "Pick & Pack Report",
  [CHILDREN_TAB_INBOUND_RECEIVING_PUTAWAY]: "Inbound Receiving & Put-away",
  [CHILDREN_TAB_RETURNS_RECEIVING]: "Returns Receiving",
  [CHILDREN_TAB_RETURNS_PROCESSING_REPORT]: "Returns Processing Report",
  [CHILDREN_TAB_CONSOLIDATION]: "Consolidation",
  [CHILDREN_TAB_LOCATION_CAPACITY]: "Location Capacity",
  [CHILDREN_TAB_LOCATION_CAPACITY_SHEET_SYNC]: "Capacity Sheet Sync",
  [CHILDREN_TAB_FBA_TRANSFERS]: "Amazon FBA Transfers",
  [CHILDREN_TAB_AMAZON_FBA_INVENTORY]: "Amazon FBA Inventory",
  [CHILDREN_TAB_INVENTORY_TRANSFERS]: "Inventory Transfer",
  [CHILDREN_TAB_HOURLY_PERFORMANCE]: "Command Center",
  [CHILDREN_TAB_SHIPMENTS]: "Inbound Shipments",
  [CHILDREN_TAB_ORDERS]: "Orders",
  [CHILDREN_TAB_PURCHASE_ORDERS]: "Purchase Orders",
  [CHILDREN_TAB_OPEN_TO_BUY]: "OTB",
  [CHILDREN_TAB_DEMAND_DESTRIBUTON_PROFILE]: "DDP",
  [CHILDREN_TAB_STOCK_LEVELS]: "Stock Levels",
  [CHILDREN_TAB_STOCK_LEVELS_AMAZON_FBA]: "Stock Levels: Amazon FBA",
  [CHILDREN_TAB_AMAZON_FBA_LOW_STOCK_ALERTS]: "Amazon FBA Low Stock Alerts",
  [CHILDREN_TAB_PRODUCTS_CATALOG]: "Product Catalog",
  [CHILDREN_TAB_MERCHANDISING_KPIS]: "Merchandising KPIs",
  [CHILDREN_TAB_SKU_MAPPING]: "SKU Mapping",
  [CHILDREN_TAB_BOM]: "BOM",
  [CHILDREN_TAB_INVENTORY_RECLASSIFY]: "Reclassify Inventory",
  [CHILDREN_TAB_SUPPLIERS]: "Suppliers",
  [CHILDREN_TAB_REPORTS]: "Reports",
  [CHILDREN_TAB_AMAZON_PROFIT_BY_PRODUCT]: "Amazon Profit by Product",
  [CHILDREN_TAB_AMAZON_PROFIT_BY_SKU]: "Amazon Profit by SKU",
  [CHILDREN_TAB_MEC_CLOSE_CHECKLIST]: "Close Checklist",
  [CHILDREN_TAB_MEC_CLOSE_APPROVAL]: "Close Approvals",
  [CHILDREN_TAB_MEC_JE_DRAFTS]: "Journal Entry Drafts",
  [CHILDREN_TAB_MEC_JE_POSTING]: "MEC JE Posting",
  [CHILDREN_TAB_MEC_EVIDENCE_IMPORTS]: "MEC Evidence Imports",
  [CHILDREN_TAB_MEC_CLOSE_CONFIG]: "Close Configuration",
  [CHILDREN_TAB_MEC_CLOSE_CERTIFICATION]: "Close Certification",
  [CHILDREN_TAB_MEC_SUPPORTING_REPORTS]: "Supporting Reports",
  [CHILDREN_TAB_MEC_PHYSICAL_ROLLFORWARD]: "Physical Rollforward",
  [CHILDREN_TAB_MONTH_END_INVENTORY]: "Month-End Inventory",
  [CHILDREN_TAB_USERS]: "Users",
  [CHILDREN_TAB_CRON]: "Cron",
  [CHILDREN_TAB_APP_NOTES]: "App Notes",
  [CHILDREN_TAB_NOTIFICATION_SETTINGS]: "Notification Settings",
  [CHILDREN_TAB_KLAVIYO_ANALYTICS]: "Klaviyo Analytics",
  [CHILDREN_TAB_CREATIVE_OS_MIRROR]: "Creative OS Mirror",
  [CHILDREN_TAB_TRYBE_CONTEST]: "Trybe Creator Contest",
};

const defaultPermissions = [
  {
    [TAB_FINANCE]: [
      { [CHILDREN_TAB_HOURLY_PERFORMANCE]: "edit" },
      { [CHILDREN_TAB_EFFECTIVE_CAPITAL_SUMMARY]: "edit" },
      { [CHILDREN_TAB_THIRTEEN_WEEK_CASH_FLOW]: "edit" },
      { [CHILDREN_TAB_PROFIT_AND_LOSS]: "edit" },
      { [CHILDREN_TAB_BUDGET_X_FORECAST]: "edit" },
      { [CHILDREN_TAB_BUDGET_SHEET_IMPORT]: "edit" },
      { [CHILDREN_TAB_BUDGET_TEMPLATE_SHEET_LOAD]: "edit" },
      { [CHILDREN_TAB_BALANCE_SHEET]: "edit" },
      { [CHILDREN_TAB_CASH_FLOW]: "edit" },
      { [CHILDREN_TAB_ACCOUNTS_PAYABLE]: "edit" },
      { [CHILDREN_TAB_COGS_CANONICAL_VIEW]: "edit" },
      { [CHILDREN_TAB_REPORTS]: "edit" },
      { [CHILDREN_TAB_AMAZON_PROFIT_BY_PRODUCT]: "view" },
      { [CHILDREN_TAB_AMAZON_PROFIT_BY_SKU]: "view" },
      { [CHILDREN_TAB_MEC_CLOSE_CHECKLIST]: "edit" },
      { [CHILDREN_TAB_MEC_PHYSICAL_ROLLFORWARD]: "view" },
      { [CHILDREN_TAB_MONTH_END_INVENTORY]: "edit" },
      { [CHILDREN_TAB_MEC_CLOSE_APPROVAL]: "edit" },
      { [CHILDREN_TAB_CREATIVE_OS_MIRROR]: "edit" },
    ],
  },
  {
    [TAB_MERCHANDISING]: [
      { [CHILDREN_TAB_STOCK_LEVELS]: "edit" },
      { [CHILDREN_TAB_STOCK_LEVELS_AMAZON_FBA]: "edit" },
      { [CHILDREN_TAB_AMAZON_FBA_LOW_STOCK_ALERTS]: "edit" },
      { [CHILDREN_TAB_PRODUCTS_CATALOG]: "edit" },
      { [CHILDREN_TAB_MERCHANDISING_KPIS]: "view" },
      { [CHILDREN_TAB_OPEN_TO_BUY]: "edit" },
      { [CHILDREN_TAB_PURCHASE_ORDERS]: "edit" },
      { [CHILDREN_TAB_FORECAST_PLANNING_SYSTEM]: "edit" },
      { [CHILDREN_TAB_DEMAND_PLANNING]: "edit" },
      { [CHILDREN_TAB_DEMAND_PLAN_SHEET_IMPORT]: "edit" },
      { [CHILDREN_TAB_DEMAND_DESTRIBUTON_PROFILE]: "edit" },
      { [CHILDREN_TAB_BOM]: "edit" },
      { [CHILDREN_TAB_SKU_MAPPING]: "edit" },
      { [CHILDREN_TAB_INVENTORY_RECLASSIFY]: "edit" },
    ]
  },
  {
    [TAB_FULFILLMENT]: [
      { [CHILDREN_TAB_SHIPMENTS]: "edit" },
      { [CHILDREN_TAB_ORDERS]: "edit" },
      { [CHILDREN_TAB_RECEIVED_BOXES]: "edit" },
      { [CHILDREN_TAB_LOCATION_MASTER]: "edit" },
      { [CHILDREN_TAB_INVENTORY_LEDGER]: "edit" },
      { [CHILDREN_TAB_PICK_PACK_REPORT]: "view" },
      { [CHILDREN_TAB_INBOUND_RECEIVING_PUTAWAY]: "view" },
      { [CHILDREN_TAB_CONSOLIDATION]: "edit" },
      { [CHILDREN_TAB_LOCATION_CAPACITY]: "view" },
      { [CHILDREN_TAB_LOCATION_CAPACITY_SHEET_SYNC]: "view" },
      { [CHILDREN_TAB_FBA_TRANSFERS]: "edit" },
      { [CHILDREN_TAB_AMAZON_FBA_INVENTORY]: "view" },
      { [CHILDREN_TAB_INVENTORY_TRANSFERS]: "edit" },
      { [CHILDREN_TAB_RETURNS_RECEIVING]: "edit" },
      { [CHILDREN_TAB_RETURNS_PROCESSING_REPORT]: "view" },
    ],
  },
  {
    [TAB_VENDORS]: [
      { [CHILDREN_TAB_SUPPLIERS]: "edit" },
    ],
  },
  {
    [TAB_UTILITIES]: [
      { [CHILDREN_TAB_USERS]: "edit" },
      { [CHILDREN_TAB_CRON]: "edit" },
      { [CHILDREN_TAB_APP_NOTES]: "edit" },
      { [CHILDREN_TAB_NOTIFICATION_SETTINGS]: "edit" },
    ],
  },
];

const enumUserRoles = {
    [ADMIN]: 'Admin',
    [FINANCE]: 'Finance',
    [TEAM]: 'Team',
    [VENDOR]: 'Vendor',
    [DIRECTOR]: 'Director'
};

const enumUserStatuses = {
    [ACTIVE]: "Active",
    [INACTIVE]: "Inactive",
}

module.exports = {
    enumUserRoles,
    enumUserStatuses,
    defaultPermissions,
    DEPRECATED_PERMISSION_CHILDREN,
    MERCHANDISING_ADOPTED_CHILDREN,
    normalizeLegacyPermissionParents,
    enumPermissions,
    enumPermissionChildren,
    ACTIVE,
    INACTIVE,
    ADMIN,
    FINANCE,
    TEAM,
    VENDOR,
    DIRECTOR,
    isAdminRole,
    TAB_FINANCE,
    TAB_MARKETING,
    TAB_MERCHANDISING,
    TAB_FULFILLMENT,
    TAB_INVENTORY,
    TAB_VENDORS,
    TAB_UTILITIES,
    CHILDREN_TAB_ACCOUNTS_PAYABLE,
    CHILDREN_TAB_MEC_CLOSE_CHECKLIST,
    CHILDREN_TAB_MEC_CLOSE_APPROVAL,
    CHILDREN_TAB_MEC_JE_DRAFTS,
    CHILDREN_TAB_MEC_JE_POSTING,
    CHILDREN_TAB_MEC_EVIDENCE_IMPORTS,
    CHILDREN_TAB_MEC_CLOSE_CONFIG,
    CHILDREN_TAB_MEC_CLOSE_CERTIFICATION,
    CHILDREN_TAB_MEC_SUPPORTING_REPORTS,
    CHILDREN_TAB_MEC_PHYSICAL_ROLLFORWARD,
    CHILDREN_TAB_MONTH_END_INVENTORY,
    CHILDREN_TAB_SKU_MAPPING,
    CHILDREN_TAB_BOM,
    CHILDREN_TAB_INVENTORY_RECLASSIFY,
    CHILDREN_TAB_PRODUCTS_CATALOG,
    CHILDREN_TAB_MERCHANDISING_KPIS,
    CHILDREN_TAB_FORECAST_PLANNING_SYSTEM,
    CHILDREN_TAB_DEMAND_PLANNING,
    CHILDREN_TAB_DEMAND_PLAN_SHEET_IMPORT,
    CHILDREN_TAB_PROFIT_AND_LOSS,
    CHILDREN_TAB_BALANCE_SHEET,
    CHILDREN_TAB_COGS_CANONICAL_VIEW,
    CHILDREN_TAB_CASH_FLOW,
    CHILDREN_TAB_FINANCE_CHAT,
    CHILDREN_TAB_EFFECTIVE_CAPITAL_SUMMARY,
    CHILDREN_TAB_THIRTEEN_WEEK_CASH_FLOW,
    CHILDREN_TAB_RECEIVED_BOXES,
    CHILDREN_TAB_LOCATION_MASTER,
    CHILDREN_TAB_INVENTORY_LEDGER,
    CHILDREN_TAB_PICK_PACK_REPORT,
    CHILDREN_TAB_INBOUND_RECEIVING_PUTAWAY,
    CHILDREN_TAB_CONSOLIDATION,
    CHILDREN_TAB_LOCATION_CAPACITY,
    CHILDREN_TAB_LOCATION_CAPACITY_SHEET_SYNC,
    CHILDREN_TAB_FBA_TRANSFERS,
    CHILDREN_TAB_AMAZON_FBA_INVENTORY,
    CHILDREN_TAB_INVENTORY_TRANSFERS,
    CHILDREN_TAB_RETURNS_RECEIVING,
    CHILDREN_TAB_RETURNS_PROCESSING_REPORT,
    CHILDREN_TAB_BUDGET_X_FORECAST,
    CHILDREN_TAB_BUDGET_SHEET_IMPORT,
    CHILDREN_TAB_BUDGET_TEMPLATE_SHEET_LOAD,
    CHILDREN_TAB_BUDGET,
    CHILDREN_TAB_FORECAST,
    CHILDREN_TAB_CREATIVE_OS_MIRROR,
    CHILDREN_TAB_HOURLY_PERFORMANCE,
    CHILDREN_TAB_SHIPMENTS,
    CHILDREN_TAB_ORDERS,
    CHILDREN_TAB_PURCHASE_ORDERS,
    CHILDREN_TAB_OPEN_TO_BUY,
    CHILDREN_TAB_DEMAND_DESTRIBUTON_PROFILE,
    CHILDREN_TAB_STOCK_LEVELS,
    CHILDREN_TAB_STOCK_LEVELS_AMAZON_FBA,
    CHILDREN_TAB_AMAZON_FBA_LOW_STOCK_ALERTS,
    CHILDREN_TAB_PRODUCTS,
    CHILDREN_TAB_CATALOG,
    CHILDREN_TAB_SUPPLIERS,
    CHILDREN_TAB_REPORTS,
    CHILDREN_TAB_AMAZON_PROFIT_BY_PRODUCT,
    CHILDREN_TAB_AMAZON_PROFIT_BY_SKU,
    CHILDREN_TAB_USERS,
    CHILDREN_TAB_CRON,
    CHILDREN_TAB_APP_NOTES,
    CHILDREN_TAB_NOTIFICATION_SETTINGS,
    CHILDREN_TAB_EXISTED_SKUS_COMPARISON,
    CHILDREN_TAB_KLAVIYO_ANALYTICS,
    CHILDREN_TAB_TRYBE_CONTEST
}